// Génération PDF de la carte ID salarié (format carte de crédit)
import jsPDF from "jspdf";

export async function generateCardIdPDF({ salarie, entreprise, qrDataUrl }) {
  // Format CR80 = 85.6 x 53.98 mm — on construit en mm
  const W = 85.6;
  const H = 53.98;
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [W, H] });

  // Background noir
  doc.setFillColor(10, 10, 10);
  doc.rect(0, 0, W, H, "F");

  // Bandeau Klein Blue gauche
  doc.setFillColor(0, 47, 167);
  doc.rect(0, 0, 6, H, "F");

  // Bandeau jaune en bas droite
  doc.setFillColor(255, 215, 0);
  doc.rect(W - 28, H - 5, 28, 5, "F");

  // Logo zone (pas d'image -> texte PAG)
  doc.setFont("helvetica", "bold");
  doc.setTextColor(255, 215, 0);
  doc.setFontSize(7);
  doc.text("// PAG BUSINESS MANAGER", 9, 6);

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(16);
  doc.text("CARTE D'IDENTITÉ", 9, 13);
  doc.setFontSize(8);
  doc.setTextColor(160, 160, 160);
  doc.text("PROFESSIONNELLE", 9, 17);

  // Bloc nom
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.text(`${(salarie.prenom || "").toUpperCase()} ${(salarie.nom || "").toUpperCase()}`, 9, 26);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.setTextColor(200, 200, 200);
  doc.text(`Poste : ${salarie.poste || "—"}`, 9, 30);
  doc.text(`Contrat : ${salarie.contrat || "—"}`, 9, 33.5);

  // Code d'accès (mono, jaune)
  doc.setFont("courier", "bold");
  doc.setFontSize(11);
  doc.setTextColor(255, 215, 0);
  doc.text(salarie.code || "PAG-SAL-XXXX", 9, 40);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);
  doc.setTextColor(160, 160, 160);
  doc.text("CODE D'ACCÈS PAG", 9, 43);

  // Entreprise en bas
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.setTextColor(255, 255, 255);
  const entrepriseLabel = (entreprise?.name || "").substring(0, 40);
  doc.text(entrepriseLabel, 9, 49);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);
  doc.setTextColor(160, 160, 160);
  doc.text(entreprise?.code || "", 9, 51.5);

  // QR Code à droite
  if (qrDataUrl) {
    doc.addImage(qrDataUrl, "PNG", W - 24, 8, 18, 18);
    doc.setFontSize(5);
    doc.setTextColor(255, 255, 255);
    doc.text("Scan profil", W - 22, 28);
  }

  return doc;
}
